import type { ScreeningSystemRow } from './projectsApi'

// A name in an index is not an assessment. Keep the source row for audit and
// later vendor input, but don't present a name-only placeholder as a finding.
function informative(value: string | null | undefined): boolean {
  const text = value?.trim()
  if (!text) return false
  return !/^(?:[-—–?]+|n\/?a|none|null|unknown|not (?:known|available|provided|specified|assessed|screened)|no (?:information|data|evidence)(?: available| provided)?|tbu|tbd)$/i.test(text)
}

export function hasUsableScreeningInformation(row: ScreeningSystemRow): boolean {
  // Failure/coverage warnings belong in the visible review queue even when
  // their drawing could not be read. Hiding failures would imply completion.
  if (row.status === 'failed' || row.status === 'pending_maker_drawing') return true
  if (row.ip === 'Yes' || row.ip === 'No') return true
  if (row.evidence?.some(item => [item.quote, item.cable_type, item.interface_device].some(informative))) return true
  if (row.pending_contacts?.length) return true
  return [row.maker, row.model, row.detail, row.connected_system, row.remark].some(informative)
}

// A legacy mismatch flag is only a name/title comparison. It does not establish
// that a page or its evidence belongs to a different system. Keep it available
// as source context, not a red finding or a proven evidence conflict.
export function hasTitleAssociationNote(row: ScreeningSystemRow): boolean {
  return row.mismatch === true
}
